module.exports = __webpack_public_path__ + "img/1right.bcd8b74c.png";